<template>
  <div class="col-12">
    <div v-if="Object.values(curriculum).length < 1">
      Sin datos
    </div>
    <div
      v-else
      class="row"
    >
      <PensumChart
        :chart-data="chartData(curriculum)"
        :options="pieChartOptions"
        :tooltips="true"
        class="col-12 col-lg-5 col-xl-3"
      />
      <PensumHours
        :hours="hours"
        class="col-12 col-lg-7 col-xl-4"
      />
      <div class="col-12 col-xl-4 p-2">
        <base-button
          :disabled="!link.length"
          type="button"
          inverse
          @click="openTab()"
        >
          Busca Pensum aquí <fa-icon
            v-if="link.length > 0"
            icon="external-link-alt"
          />
        </base-button>
      </div>
      <div class="col-12" />
    </div>
  </div>
</template>
<script>
import CONFIG from '../../config';
import PensumChart from '../../components/Charts/PensumChart.vue';
import PensumHours from '../../components/PensumHours.vue';

export default {
    name: 'Curriculum',
    components: {
        PensumChart,
        PensumHours,
    },
    props: {
        curriculum: {
            type: Object,
            dafault: {},
        },
        hours: {
            type: Object,
            default() { return {}; },
        },
        link: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            pieChartOptions: {
                responsive: true,
                legend: {
                    display: true,
                },
                tooltips: {
                    bodyFontSize: 12,
                },
            },
        };
    },
    mounted() {},
    methods: {
        chartData(pensum) {
            return {
                datasets: [
                    {
                        backgroundColor: [
                            CONFIG.COLORS.pensum.cuantitative,
                            CONFIG.COLORS.pensum.cualitative,
                            CONFIG.COLORS.pensum.optative,
                            CONFIG.COLORS.pensum.profesional,
                        ],
                        data: Object.values(pensum).map(v => Number(v).toFixed(2)),
                    },
                ],
                labels: Object.keys(pensum),
            };
        },
        openTab() {
            window.open(this.link, '_blank');
        },
    },
};
</script>
